export const SET_HOTEL = 'GUIDE/SET_HOTEL'
